/**
 * Created with IntelliJ IDEA.
 * User: orenm
 * Date: 12/29/14
 * Time: 7:04 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";
    var CP_CONST = require("connection-const");
    var PageSnippetsCollection = require("connection-collections/KPsTab/PageSnippetsCollection");
    var NewSnippetsCollection = require("connection-collections/KPsTab/NewSnippetsCollection");
    var KPsSnippetsCompositeView = require("connection-views/KPsTab/KPsSnippetsCompositeView");
    var KPsSnippetsCompositeModel = require("connection-models/KPsTab/KPsSnippetsCompositeModel");

    var PageSnippetsController = {};
    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {
        PageSnippetsController = Marionette.Controller.extend({
            pageReferrerAction: CP_CONST.REFERER_ACTION.PAGE_SNIPPET,
            newReferrerAction: CP_CONST.REFERER_ACTION.NEW_SNIPPET,

            initialize: function (options) {
                this.connectionPanelContextModel = options.connectionPanelContextModel;
                var page = this.connectionPanelContextModel.get("context.page");
                if(page){
                    this._fetchPage( this.connectionPanelContextModel,page);
                }
                this._setEventListeners();
            },

            _setEventListeners: function () {
                this.listenTo(this.connectionPanelContextModel, "change:context.page", this._fetchPage, this);
                this.listenTo(this.connectionPanelContextModel, "change:context.activities", this._prioritize, this);
                this.listenTo(this.connectionPanelContextModel, "change:selectedKP", this._onSelectedKPChange, this);
            },

            _setNewCollectionFromPageCollection: function (newSnippetsArray) {
                this.newSnippetsCollection = this._getNewSnippetsCollection();
                this.newSnippetsCollection.set(newSnippetsArray);
            },

            _getNewSnippetsArray: function () {
                var filterCriteria = {"isNew": true};
                return  this.pageSnippetsCollection.where(filterCriteria);
            },

            _prioritize: function (model, activities) {
                if (this._getPageSnippetsCollection().models.length > 0) {
                    this._getPageSnippetsCollection().prioritize(activities);
                    this._showPageSnippetCompositeView();
                }
            },

            _fetchPage: function (model, page) {
                if(page){
                    var permissionGroup;
                    this.pageSnippetsCollection = this._getPageSnippetsCollection();
                    var area = this.connectionPanelContextModel.get("context.area");
                    var lang = this.connectionPanelContextModel.get("locale");
                    if (LE && LE.sessionManager && LE.sessionManager.hasPrivilege) {
                        permissionGroup = LE.sessionManager.getPermissionGroupByPrivilege();
                    }
                    if (!_.isNull(permissionGroup)) {
                        page = page + "-" + permissionGroup;
                    }
                    this.pageSnippetsCollection.fetch({
                        area: area,
                        page: page,
                        lang: lang,
                        userId:this.connectionPanelContextModel.get("userId"),
                        accountId:this.connectionPanelContextModel.get("accountId"),
                        success: _.bind(this._onPageFetchSuccess, this),
                        error: _.bind(this._onPageFetchError, this)
                    });
                }
                else{
                    this._hideNewSnippetCompositeView();
                    this._hidePageSnippetCompositeView();
                }
            },
            _onPageFetchSuccess: function (collection) {
                LEConnection.trigger("page:updated");

                var newSnippetsArray = this._getNewSnippetsArray();
                this._setNewCollectionFromPageCollection(newSnippetsArray);

                if (newSnippetsArray.length > 0) {
                    this.pageSnippetsCollection.remove(newSnippetsArray);
                    this._showNewSnippetCompositeView();
                }
                else {
                    this._hideNewSnippetCompositeView();
                }

                if (collection.length > 0) {
                    this._showPageSnippetCompositeView();
                }
                else {
                    this._hidePageSnippetCompositeView();
                }
            },
            _onPageFetchError: function (collection) {
                LEConnection.trigger("page:updated");
                LEConnection.logger.error("Failed to fetch Page Collection:", "PageSnippetsController:_fetchPage");
                this._hideNewSnippetCompositeView();
                this._hidePageSnippetCompositeView();
                this._setNoData();
                //todo: add error
            },

            _getPageSnippetsCollection: function () {
                if (!this.pageSnippetsCollection) {
                    this.pageSnippetsCollection = new PageSnippetsCollection();
                }
                return this.pageSnippetsCollection;
            },
            _getNewSnippetsCollection: function () {
                if (!this.newSnippetsCollection) {
                    this.newSnippetsCollection = new NewSnippetsCollection();
                    this.connectionPanelContextModel.setNewSnippetsCollection(this.newSnippetsCollection);
                }
                return this.newSnippetsCollection;
            },
            _hideNewSnippetCompositeView: function () {
                LEConnection.vent.trigger("KPsTabController::closeRegion:whatsNewRegion");
            },
            _showNewSnippetCompositeView: function () {
                if (!this.newSnippetCompositeView) {
                    this._setNewSnippetCompositeView();
                }
                if (_.isUndefined(this.newSnippetCompositeView.isClosed) || this.newSnippetCompositeView.isClosed) {
                    LEConnection.vent.trigger("KPsTabController::showRegion:whatsNewRegion", {view: this.newSnippetCompositeView});
                }
            },
            _setNewSnippetCompositeView: function () {
                var kpsSnippetsCompositeModel = new KPsSnippetsCompositeModel({
                    listTitle: LE.translator.translate("LEConnection."+this.newReferrerAction)
                });

                this.newSnippetCompositeView = new KPsSnippetsCompositeView({
                    collection: this._getNewSnippetsCollection(),
                    type: this.newReferrerAction,
                    model: kpsSnippetsCompositeModel
                });

            },
            _hidePageSnippetCompositeView: function () {
                LEConnection.vent.trigger("KPsTabController::closeRegion:pageRegion");
            },
            _showPageSnippetCompositeView: function () {
                if (!this.pageSnippetCompositeView) {
                    this._setPageSnippetCompositeView();
                }
                if (_.isUndefined(this.pageSnippetCompositeView.isClosed) || this.pageSnippetCompositeView.isClosed) {
                    LEConnection.vent.trigger("KPsTabController::showRegion:pageRegion", {view: this.pageSnippetCompositeView});
                }else{
                    this.pageSnippetCompositeView.render();
                }
            },
//            _reRenderPageSnippetCompositeView: function () {
//                if (_.isUndefined(this.pageSnippetCompositeView.isClosed) || this.pageSnippetCompositeView.isClosed) {
//                    LEConnection.vent.trigger("KPsTabController::showRegion:pageRegion", {view: this.pageSnippetCompositeView});
//                }
//                else {
//                    this.pageSnippetCompositeView.render();
//                }
//            },
            _setPageSnippetCompositeView: function () {
                var kpsSnippetsCompositeModel = new KPsSnippetsCompositeModel({
                    listTitle: LE.translator.translate("LEConnection."+this.pageReferrerAction)
                });

                this.pageSnippetCompositeView = new KPsSnippetsCompositeView({
                    collection: this._getPageSnippetsCollection(),
                    type: this.pageReferrerAction,
                    model: kpsSnippetsCompositeModel
                });

            },
            _onSelectedKPChange: function (model, selectedKP) {
                var slug;
                //page

                if (this.pageSnippetCompositeView) {
                    if (selectedKP && this.pageReferrerAction === this.connectionPanelContextModel.get("referrerAction")) {
                        slug = selectedKP.get("slug");
                        this.pageSnippetCompositeView.setSelected(slug);
                    }
                    else {
                        this.pageSnippetCompositeView.unSelectAll();
                    }
                }
                //new
                if (this.newSnippetCompositeView) {
                    if (selectedKP && this.newReferrerAction === this.connectionPanelContextModel.get("referrerAction")) {
                        slug = selectedKP.get("slug");
                        this.newSnippetCompositeView.setSelected(slug);
                    }
                    else {
                        this.newSnippetCompositeView.unSelectAll();
                    }
                }
            },

            findSlugInCollection: function (slug) {
                var returnedModel;
                if(this.pageSnippetsCollection) {
                    returnedModel = this.pageSnippetsCollection.findWhere({slug: slug});
                }


                if(!returnedModel && this.newSnippetsCollection) {
                    returnedModel = this.newSnippetsCollection.findWhere({slug: slug});
                }

                return returnedModel;
            },
            _setNoData:function(){
                LEConnection.vent.trigger("KPsTabController::noData:show");
            }
        });
    });
    return PageSnippetsController;
});





